import { Component, Input, OnInit } from '@angular/core';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { Router } from '@angular/router';
import { WaterBodyNavigationService } from '../../../core/services/navigation/water-body-navigation.service';

@Component({
  selector: 'app-buyflow-no-boats-found',
  templateUrl: './buyflow-no-boats-found.component.html',
  styleUrls: ['./buyflow-no-boats-found.component.scss'],
})
export class BuyflowNoBoatsFoundComponent implements OnInit {
  @Input()
  activeWaterBodies: WaterBody[];

  constructor(
    private router: Router,
    private waterBodyNavigationService: WaterBodyNavigationService,
  ) {}

  ngOnInit() {}

  navToWaterBody(vanityUrl: string) {
    this.waterBodyNavigationService.nav(vanityUrl);
  }
}
